import React, { useState, useContext } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import SingInForm from "../pages/auth/forms/SingInForm";
import {
    UiAuthContainer
} from "../_uiComponents/common/custom/header/UiTopNavElements";
import UiInlineErrorMessage from "../_uiComponents/form/UiInlineErrorMessage";
import UiInlineSuccessMessage from "../_uiComponents/form/UiInlineSuccessMessage";


export default function Application(props) {

    const location = useLocation()
    return (
        <>
            <UiAuthContainer>
                <div className="sb-auth-top-wr">
                    <h2>Login</h2>
                    {/* <UiInlineErrorMessage/>
                    <UiInlineSuccessMessage/> */}
                    <SingInForm />
                </div>
            </UiAuthContainer>
        </>
    );
}
